import {Injectable} from "@angular/core";
import {Job} from "./job.model";
import {URLSearchParams, Response} from "@angular/http";
import {Observable} from "rxjs/Observable";
import {environment} from "../../../app/config/environment";
import {MyHttp} from "../../../app/core/http";
import {AppAuth} from "../../../app/core/auth";
import {ReplaySubject} from "rxjs/ReplaySubject";

@Injectable()
export class JobService {

  private jobEndsAtWatchInterval;

  private collectionStateObs$ = new ReplaySubject<{user_id: number}>(1);

  constructor(private http: MyHttp, private auth: AppAuth) {
    auth.getAuthStatus().subscribe(() => this.initCurrentUserState());
  }

  getCollectionState(){
    return this.collectionStateObs$;
  }

  updateCollectionState(state: {user_id: number}){
    this.collectionStateObs$.next(state);
  }

  getPublicJobs() {
    return this.http.get(`${environment.API}/jobs/public`)
      .map(res => res.json())
      .map(this.formatJobs);
  }

  getMyJobs(filter: string, role:string, user_id: string) {
    // Set filter params
    let params: URLSearchParams = new URLSearchParams();
    params.set('filter', filter);
    params.set('user_id', user_id);

    // Do request
    return this.http.get(`${environment.API}/jobs/${role === 'interpreter' ? 'me' : 'organisation'}`, {search: params})
      .map(res => res.json())
      .map(this.formatJobs);
  }

  getJob(id) : Observable<Response> {
    return this.http.get(`${environment.API}/jobs/${id}`)
      .map(res => res.json());
  }


  saveJob(job){
    return this.http.post(`${environment.API}/jobs`, JSON.stringify(job))
      .map(res => res.json());
  }

  updateJob(job){
    return this.http.patch(`${environment.API}/jobs/${job.id}`, JSON.stringify(job))
      .map(res => res.json());
  }

  acceptJob(job) {
    return this.http.post(`${environment.API}/jobs/${job.id}/accept`, JSON.stringify(job))
      .map(res => res.json());
  }

  finishJob(id, finished_at) {
    return this.http.post(`${environment.API}/jobs/${id}/finished_at`, JSON.stringify({
      finished_at: finished_at
    }))
      .map(res => res.json());
  }

  updateAddress(job) {
    return this.http.post(`${environment.API}/jobs/${job.id}/address`, JSON.stringify(job))
      .map(res => res.json());
  }

  cancelJob(id: number, reason: string) {
    return this.http.post(`${environment.API}/jobs/${id}/cancel`, JSON.stringify({
      reason: reason
    }))
      .map(res => res.json());
  }

  rejectJob(id: number, reason: string) {
    return this.http.post(`${environment.API}/jobs/${id}/reject`, JSON.stringify({
      reason: reason
    }))
      .map(res => res.json());
  }

  unpublishJob(id){
    return this.http.get(`${environment.API}/jobs/${id}/unpublish`)
      .map(res => res.json());
  }

  deleteJob(id){
    return this.http.delete(`${environment.API}/jobs/${id}`)
      .map(res => res.json());
  }

  rateJob(job) {
    return this.http.post(`${environment.API}/jobs/${job.id}/rate`, JSON.stringify(job))
      .map(res => res.json());
  }

  reviewJob(job) {
    return this.http.post(`${environment.API}/jobs/${job.id}/review`, JSON.stringify(job))
      .map(res => res.json());
  }

  submitFiles(job){
    return this.http.get(`${environment.API}/jobs/${job.id}/attachments/submit`)
      .map(res => res.json());
  }

  /**
   * Check in an interval if the job has reached ends_at
   * Only start watching if the job is not done and ends_at is in the future
   */
  startWatchingIfJobDone(job){
    // console.log('start watching if job done');
    if(!this.jobEndsAtWatchInterval && job.endsAtIsInFuture() && job.status !== 'done'){
      this.jobEndsAtWatchInterval = setInterval(() => {

        // console.log('watching');

        // Check if the job has reached ends_at
        if(!job.endsAtIsInFuture()){
          job.status = 'done';
          this.stopWatchingIfJobDone();
        }
      }, 1000);
    }
  }

  stopWatchingIfJobDone(){
    // console.log('stopping watching ends at ');
    clearInterval(this.jobEndsAtWatchInterval);
  }

  private formatJobs(jobs) {
    return jobs.map((job) => {
      return new Job(job);
    });
  }

  private initCurrentUserState(){
    this.updateCollectionState({user_id: this.auth.user ? this.auth.user.sub : null});
  }

  addSignature(jobId: number, signatureData: string, name: string) {
    let data = {
      signature: signatureData,
      name: name
    };

    return this.http.post(`${environment.API}/jobs/${jobId}/sign`, JSON.stringify(data))
      .map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/pages/job/shared/job.service.ts